import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppRoot } from '@telegram-apps/telegram-ui';
import App from './App';

// Import Telegram UI styles
import '@telegram-apps/telegram-ui/dist/styles.css';

// Initialize Telegram WebApp with theme support
if (window.Telegram?.WebApp) {
  const webApp = window.Telegram.WebApp;
  webApp.ready();
  webApp.expand();

  // Apply theme
  const themeParams = webApp.themeParams;
  document.documentElement.style.setProperty('--tg-theme-bg-color', themeParams.bg_color || '#ffffff');
  document.documentElement.style.setProperty('--tg-theme-text-color', themeParams.text_color || '#000000');
  document.documentElement.style.setProperty('--tg-theme-hint-color', themeParams.hint_color || '#707579');
  document.documentElement.style.setProperty('--tg-theme-link-color', themeParams.link_color || '#3390ec');
  document.documentElement.style.setProperty('--tg-theme-button-color', themeParams.button_color || '#3390ec');
  document.documentElement.style.setProperty('--tg-theme-button-text-color', themeParams.button_text_color || '#ffffff');
  document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', themeParams.secondary_bg_color || '#f1f1f1');
  document.documentElement.style.setProperty('--tg-theme-section-header-text-color', themeParams.subtitle_text_color || '#707579');

  // Listen for theme changes
  webApp.onEvent('themeChanged', () => {
    const tp = webApp.themeParams;
    document.documentElement.style.setProperty('--tg-theme-bg-color', tp.bg_color || '#ffffff');
    document.documentElement.style.setProperty('--tg-theme-text-color', tp.text_color || '#000000');
    document.documentElement.style.setProperty('--tg-theme-hint-color', tp.hint_color || '#707579');
    document.documentElement.style.setProperty('--tg-theme-link-color', tp.link_color || '#3390ec');
    document.documentElement.style.setProperty('--tg-theme-button-color', tp.button_color || '#3390ec');
    document.documentElement.style.setProperty('--tg-theme-button-text-color', tp.button_text_color || '#ffffff');
    document.documentElement.style.setProperty('--tg-theme-secondary-bg-color', tp.secondary_bg_color || '#f1f1f1');
    document.documentElement.style.setProperty('--tg-theme-section-header-text-color', tp.subtitle_text_color || '#707579');
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppRoot>
      <App />
    </AppRoot>
  </StrictMode>,
);
